<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <!-- <div class="container">
      <backtospeisekarte></backtospeisekarte>
    </div> -->
    <v-card>
      <v-card-title class="display-3">
        Temakis
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtospeisekarte from './Backtospeisekarte.vue';
export default {
  // components: {
  //   Backtospeisekarte,
  // },
  name: 'Temakis',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/temakifrontal.jpg'),
          title: '',
        },
        {
          src: require('../assets/images/temakinahaufnahme.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Anzahl', value: 'anzahl' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 'K1',
          speise: 'Oshinko Temaki (mit eingelegtem Rettich)',
          anzahl: '(1 Stk.)',
          allergene: '(/)',
          preis: '3,90 €',
        },
        {
          nummer: 'K2',
          speise: 'Gurken Temaki',
          anzahl: '(1 Stk.)',
          allergene: '(/)',
          preis: '3,90 €',
        },
        {
          nummer: 'K3',
          speise: 'Lachs Temaki',
          anzahl: '(1 Stk.)',
          allergene: '(D)',
          preis: '4,60 €',
        },
        {
          nummer: 'K4',
          speise: 'Thunfisch Temaki',
          anzahl: '(1 Stk.)',
          allergene: '(D)',
          preis: '5,40 €',
        },
        {
          nummer: 'K5',
          speise: 'California Temaki',
          anzahl: '(1 Stk.)',
          allergene: '(G, R)',
          preis: '5,40 €',
        },
        {
          nummer: 'K6',
          speise: 'Temaki im Set',
          anzahl: '(3 Stk.)',
          allergene: '(D, G, R)',
          preis: '10,90 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
